import { render, staticRenderFns } from "./OrderHistoryAddToCartButton.vue?vue&type=template&id=12f4385f&scoped=true&"
import script from "./OrderHistoryAddToCartButton.vue?vue&type=script&lang=ts&"
export * from "./OrderHistoryAddToCartButton.vue?vue&type=script&lang=ts&"
import style0 from "./OrderHistoryAddToCartButton.vue?vue&type=style&index=0&id=12f4385f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f4385f",
  null
  
)

export default component.exports